import React from 'react';

export default function ChevronTop({ size = 20, color = 'white', className = '', ...props }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 6L8 10L12 6" stroke={color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
      <path
        d="M4 6L8 10L12 6"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
